import { render, staticRenderFns } from "./policyCoveredAdd.vue?vue&type=template&id=6cf6074c&scoped=true"
import script from "./policyCoveredAdd.vue?vue&type=script&lang=js"
export * from "./policyCoveredAdd.vue?vue&type=script&lang=js"
import style0 from "./policyCoveredAdd.vue?vue&type=style&index=0&id=6cf6074c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6074c",
  null
  
)

export default component.exports